import React, { useState, useMemo, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { postApi } from "../../../api/getUser";
import { useAuth } from "../../../contexts/AuthContext";
import DataReactTable from "../../DataTable/components/DataReactTable";
import { NATEXT } from "../../../shared/constants";
import {
  AddFormButton,
  ColumnHeading,
  StatusContainer,
} from "../../../shared/components/TableElements";
import VehicleComponent from "../../../shared/components/table/components/VehicleComponent";
import { colorStatusActive, colorStatusInactive } from "../../../utils/palette";
import { useHistory, useLocation } from "react-router";
import SubscribePopup from "../../../shared/components/SubscribePopup";
import {
  daysHoursMinutes,
  formatNumber,
  getDistanceUnit,
  getTranslatedFuelTypeUnit,
  getTranslatedPMUnit,
} from "../../../shared/helpers";
import getDefaultFilterData from "../../../shared/constants/getDefaultFilterData";
import MaintenanceSchedulePopup from "../Vehicles/MaintenanceSchedulePopup";
import ActionPopup from "../../../shared/components/ActionPopup";
import useFetchData from "../../../shared/custom-hooks/useFetchData";
import getUnixTime from "date-fns/getUnixTime";
import { LinkSpan } from "../../../shared/components/form/FormElements";
import ExplorePopup from "../../../shared/components/ExplorePopup";
import { SecondaryStatus, VehicleStatus } from "../Vehicles/VehiclesTable";

const EquipmentTable = () => {
  const { t } = useTranslation("common");
  const history = useHistory();

  const location = useLocation();
  //const recommendMaintSchedule = location?.state?.recommendMaintSchedule;
  //const newVehicleId = location?.state?.newVehicleId;

  //const vehiclesList = useSelector((state) => state.vehicles.list);
  const { distance } = useSelector((state) => state.units);

  const groupsList = useSelector((state) => state.groups.list);
  const { roleId } = useSelector((state) => state.user);
  const { isViewOnly } = useAuth();
  const rowData = useSelector((state) => state.filter.rowData);
  const optionValues = useSelector((state) => state.filter.values);

  //State to show subscribe popup
  const [showSubscribePopup, setShowSubscribePopup] = useState(false);
  const [subscribePopupErrMsg, setsubscribePopupErrMsg] = useState("");

  const [showExplorePopup, setShowExplorePopup] = useState(false);

  //States for Maintenance Schedule Popup
  // const [showMaintSchedulePopup, setShowMaintSchedulePopup] = useState(false);
  // const [newVehicle, setNewVehicle] = useState(null);
  // const [showConfirmSkipPopup, setShowConfirmSkipPopup] = useState(false);

  useFetchData({
    startDate: 0,
    endDate: getUnixTime(new Date()),
    query: "get_all_assets_data",
    sortIndex: 1,
    assetType: 1,
    sortOrder: "asc",
  });

  const KPIValues = [
    {
      id: 0,
      key: "active_count",
      name: t("active_equipment"), //t("cost"),
      value: optionValues?.active_count ? +optionValues.active_count : NATEXT,
    },
    // {
    //   id: 1,
    //   name: t("vehicle_downtime"),
    //   key: "total_downtime",
    //   value: optionValues?.total_downtime
    //     ? daysHoursMinutes(optionValues.total_downtime).display
    //     : NATEXT,
    // },
  ];

  //Effect to open maintenance schedule popup
  // useEffect(() => {
  //   if (recommendMaintSchedule && vehiclesList?.length > 0 && newVehicleId) {
  //     const newVehicle = vehiclesList.find((v) => v.veh_id === newVehicleId);
  //     if (newVehicle) {
  //       setNewVehicle(newVehicle);
  //       setShowMaintSchedulePopup(true);
  //     }
  //   }
  // }, [vehiclesList]);

  const columnHeaders = useMemo(
    () => [
      {
        id: 1,
        Header: t("equipment"),
        accessor: "name",
        // sortType: (prev, curr, columnId) => {
        //   const a = prev.values[columnId];
        //   const b = curr.values[columnId];
        //   const collator = new Intl.Collator(undefined, {
        //     numeric: true,
        //     sensitivity: "base",
        //   });
        //   return collator.compare(a, b);
        // },
        //sortType: "alphanumeric",
        // Footer: 'Middle age:',
        // disableGlobalFilter: false,
        //width: getColumnWidth("name", "Vehicle"),
        disableFilters: true,
        Cell: ({ row }) => (
          <VehicleComponent
            vehicleName={row.original.name}
            groupName={row.original.group_name}
            vehicleId={row.original.veh_id}
            vehicleImg={row.original.veh_img}
            orgId={row.original.org_id}
            assetType={1}
          />
        ),
      },
      {
        id: 2,
        Header: t("year"),
        accessor: "year",
        Cell: ({ value }) => (value ? value : NATEXT),
      },
      {
        id: 3,
        Header: t("type"),
        accessor: "veh_type",
        //disableFilters: true,
        //width: getColumnWidth("fillup_date", "Date"),
        Cell: ({ value }) => (value ? value : NATEXT),
      },
      {
        id: 4,
        Header: t("status"),
        accessor: "veh_active",
        Cell: ({ row }) => <VehicleStatus status={row.original.veh_active} />,
        disableSortBy: true,
        //disableFilters: true,
        //width: 150,
      },
      {
        id: 5,
        Header: t("operational_status"),
        accessor: "veh_active",
        Cell: ({ row }) => <SecondaryStatus rowData={row.original} />,
        disableSortBy: true,
        //disableFilters: true,
        //width: 150,
      },
      {
        id: 6,
        Header: t("make"),
        accessor: "make",
        //disableFilters: true,
        //width: getColumnWidth("odo", "Odo"),
        // disableGlobalFilter: false,
        Cell: ({ value }) => (value ? value : NATEXT),
      },
      {
        id: 7,
        Header: t("model"),
        accessor: "model",
        Cell: ({ value }) => (value ? value : NATEXT),
        //disableFilters: true,
        //width: getColumnWidth("distance", "Distance"),
        // disableGlobalFilter: false,
      },
      {
        id: 8,
        Header: t("license"),
        accessor: "license_no",
        Cell: ({ value }) => (value ? value : NATEXT),
      },
      {
        id: 9,
        Header: t("vin"),
        accessor: "vin_no",
        Cell: ({ value }) => (value ? value : NATEXT),
      },
      {
        id: 10,
        Header: t("primary_meter"),
        accessor: "primary_meter",
        Cell: ({ value }) => (value ? getTranslatedPMUnit(value, t) : NATEXT),
        disableSortBy: true,
      },
      // {
      //   id: 11,
      //   Header: t("fuel_type"),
      //   accessor: "fuel_type",
      //   Cell: ({ value }) =>
      //     value ? getTranslatedFuelTypeUnit(value, t) : NATEXT,
      // },
      // {
      //   id: 12,
      //   Header: t("current_odo"), //t("fuel_type"),
      //   accessor: "odo",
      //   Cell: ({ row }) => {
      //     const { primary_meter, odo } = row?.original;
      //     let odoUnit = primary_meter === "Hours" ? primary_meter : distance;
      //     return odo
      //       ? `${formatNumber(odo)} ${getDistanceUnit(odoUnit)}`
      //       : NATEXT;
      //   },
      // },

      {
        id: 11,
        Header: t("group"),
        accessor: "group_id",
        Cell: ({ value }) => {
          return value
            ? groupsList?.find((u) => u.group_id === value)?.group_name
            : NATEXT;
        },
        //Cell: ({ value }) => (value ? value : NATEXT),

        //disableFilters: true,
        //width: 150,
      },
      {
        id: 12,
        Header: t("linked_vehicle"),
        accessor: "linked_veh_name",
        Cell: ({ value }) => (value ? value : NATEXT),
      },

      // {
      //   id: 'edit',
      //   Header: "",
      //   accessor: "edit",
      //   accessorId: "edit",
      //   Cell: () => <RowOptions />,
      //   disableSortBy: true,
      // },
    ],
    [groupsList, distance],
  );

  const handleAddEquipment = async () => {
    const apiData = {
      querystring: "get_user_subscription_status",
      source: "equipment",
    };
    const res = await postApi(apiData, "commonNew");
    let errMsg = "";
    if (res.success) {
      const { subscription_data } = res;
      if (subscription_data != "Email not found") {
        const { no_of_equipments, prod_id, prostatus, count } =
          subscription_data;

        if (prostatus == "trial" && count >= 5) {
          errMsg = t("no_pro_equipment_err_msg");
        } else {
          if (
            prostatus == "paid" &&
            prod_id == 5 &&
            count >= no_of_equipments
          ) {
            errMsg = t("no_pro_equipment_count_err_msg");
          } else if (
            prostatus == "paid" &&
            prod_id == 6 &&
            count >= no_of_equipments
          ) {
            errMsg = t("no_pro_equipment_count_err_msg");
          }
        }
      } else {
        errMsg = t("no_pro_equipment_err_msg");
      }
    } else {
      errMsg = t("no_pro_equipment_err_msg");
    }

    if (errMsg) {
      setsubscribePopupErrMsg(errMsg);
      setShowSubscribePopup(true);
      return;
    }

    history.push("equipment/addnew");
  };

  const { defaultContainsData, defaultPrimaryMeterData } =
    getDefaultFilterData();

  const initialData = useMemo(
    () => ({
      make: {
        column: "make",
        name: t("make"),
        accessor: "make",
        ...defaultContainsData,
      },
      model: {
        column: "model",
        name: t("model"),
        accessor: "model",
        ...defaultContainsData,
      },
      vehicleType: {
        column: "vehicleType",
        name: t("equipment_type"),
        accessor: "veh_type",
        ...defaultContainsData,
      },
      primaryMeter: {
        column: "primaryMeter",
        name: t("primary_meter"),
        ...defaultPrimaryMeterData,
      },
    }),
    [],
  );

  const reactTableData = {
    tableHeaderData: columnHeaders,
    tableRowsData: rowData,
  };

  return (
    <>
      {showExplorePopup && (
        <ExplorePopup
          showPopup={showExplorePopup}
          setShowPopup={setShowExplorePopup}
          exploreLink={"https://www.youtube.com/embed/s_uOc8k5MYo"}
        />
      )}
      {showSubscribePopup && (
        <SubscribePopup
          showPopup={showSubscribePopup}
          setShowPopup={setShowSubscribePopup}
          message={subscribePopupErrMsg}
        />
      )}
      <Container>
        <Row className="mx-1 d-flex align-items-center justify-content-around">
          <Col sm={10} className="d-flex align-items-center gap-2">
            <ColumnHeading>{t("small_equipment")}</ColumnHeading>
            <LinkSpan
              onClick={() => setShowExplorePopup(true)}
              style={{ alignSelf: "end" }}
            >
              {t("explore")}
            </LinkSpan>
          </Col>
          <Col
            sm={2}
            className="d-flex justify-content-end align-items-center mb-1"
          >
            {!isViewOnly && roleId !== 4 && (
              // <Link to={"/equipment/addnew"}>
              <AddFormButton
                id="add-equipment-btn"
                type="button"
                onClick={handleAddEquipment}
              >
                {t("add_equipment")}
              </AddFormButton>
              // </Link>
            )}
          </Col>
        </Row>
        <Row>
          <DataReactTable
            reactTableData={reactTableData}
            valuesArray={KPIValues}
            initialData={initialData}
          />
        </Row>
      </Container>
    </>
  );
};

export default EquipmentTable;

// export const VehicleStatus = ({ rowData }) => {
//   const vehiclesList = useSelector((state) => state.vehicles.list);
//   const { t } = useTranslation("common");
//   let selectedVehicle = vehiclesList.find((v) => v.veh_id === rowData?.veh_id);
//   let statusData = { text: "", bg: "" };

//   const vehActive = selectedVehicle?.veh_active;

//   if (vehActive == 1) {
//     statusData = { text: t("active"), bg: colorStatusActive };
//   } else {
//     statusData = { text: t("inactive"), bg: colorStatusInactive };
//   }

//   return (
//     <StatusContainer background={statusData.bg}>
//       <p
//       //style={{ color: "white" }}
//       >
//         {statusData.text}
//       </p>
//     </StatusContainer>
//   );
// };

// export const SecondaryStatus = ({ rowData }) => {
//   const { t } = useTranslation("common");
//   const { veh_active, secondary_status } = rowData;
//   let secondaryStatus = { text: t("in_service"), color: "green" };

//   if (veh_active === 1 && secondary_status === 1) {
//     secondaryStatus.text = t("out_of_service");
//     secondaryStatus.color = "red";
//   }

//   if (veh_active === 0 || veh_active === 2) {
//     secondaryStatus.text = "-";
//     secondaryStatus.color = "";
//   }

//   // if (veh_active === 0 && secondary_status === 2) {
//   //   secondaryStatus.text = t("unconfirmed");
//   //   secondaryStatus.color = "#E19C00";
//   // }

//   return (
//     <div style={{ color: secondaryStatus.color }}>{secondaryStatus.text}</div>
//   );
// };
